export default __webpack_public_path__ + "static/vfSun-758e6f67805d10d9aac3c3e4174a9ac7.png";